import { useDispatch } from 'react-redux';
import { notifyDanger } from '@gandi/notifications';
import { useTranslator } from '@gandi/translate';
import { Button } from '@gandi/ui';
import { createLogger } from 'gandi.redux-logger';
import { deleteCart, resetCart } from '../../../../modules/actions';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "buttonsBlock": "ConfirmDeletion-buttonsBlock_YJqdk",
  "confirmBlock": "ConfirmDeletion-confirmBlock_20l3i"
};
export function ConfirmDeletion({
  setConfirmDeleteCart,
  setIsDeleting
}) {
  const dispatch = useDispatch();
  const {
    __
  } = useTranslator();
  const onConfirmEmptyCart = async () => {
    try {
      await dispatch(deleteCart());
      setIsDeleting(true);
      setConfirmDeleteCart(false);
      await dispatch(resetCart());
    } catch (err) {
      const logger = createLogger('Footer -- emptyCart');
      logger.error(err, `Cannot empty cart`);
      const message = err._error || __('Unable to empty the Cart.');
      dispatch(notifyDanger({
        message
      }));
    } finally {
      setIsDeleting(false);
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: styles.confirmBlock,
    children: [/*#__PURE__*/_jsx("p", {
      children: __('Confirm removal?')
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.buttonsBlock,
      children: [/*#__PURE__*/_jsx(Button, {
        type: "button",
        intent: "danger",
        kind: "link",
        onClick: onConfirmEmptyCart,
        children: __('Yes, remove')
      }), /*#__PURE__*/_jsx(Button, {
        type: "button",
        kind: "link",
        onClick: () => setConfirmDeleteCart(false),
        children: __('Cancel')
      })]
    })]
  });
}